const ITEMS = [
  "QUALITY BPO SOLUTIONS",
  "REDUCE OPERATIONAL COSTS",
  "GROW YOUR REVENUE",
  "AROUND YOUR BUSINESS HOURS",
  "SECURE & CONFIDENTIAL",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden bg-zi-primary py-5 border-y border-white/10"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex" aria-hidden={dup === 1}>
            {row.map((item, i) => (
              <span
                key={`${dup}-${i}`}
                className="mx-8 font-heading text-lg sm:text-xl font-bold uppercase tracking-wide text-white/90 flex items-center gap-8"
              >
                {item}
                <span className="h-2 w-2 rounded-full bg-zi-accent" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
